import { Zap } from "lucide-react";
import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "src/shadcn/components/ui";

type Props = {
  TOD_IMPACT_DATA: any;
};

const ImpactofChanges = ({ TOD_IMPACT_DATA }: Props) => {
  return (
    <div className="">
      <Card className=" ">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Zap className="h-5 w-5 text-orange-500" />
            Impact of Changes in ToD Tariff and Banking Provisions
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="max-sm:w-[80vw] max-sm:overflow-auto">
            <Table>
              <TableHeader className="bg-slate-200">
                <TableRow>
                  <TableHead className="font-semibold">ToD Zone</TableHead>
                  <TableHead className="font-semibold text-center">Before MYT (Hours)</TableHead>
                  <TableHead className="font-semibold text-center">Before MYT (Units)</TableHead>
                  <TableHead className="font-semibold text-center">Before MYT (Rebate)</TableHead>
                  <TableHead className="font-semibold text-center">Before MYT (Rebate ₹)</TableHead>
                  <TableHead className="font-semibold text-center">After MYT (Hours)</TableHead>
                  <TableHead className="font-semibold text-center">After MYT (Units)</TableHead>
                  <TableHead className="font-semibold text-center">After MYT (Rebate)</TableHead>
                  <TableHead className="font-semibold text-center">After MYT (Rebate ₹)</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {TOD_IMPACT_DATA.map((row: any, index: number) => (
                  <TableRow key={index} className={index % 2 === 0 ? "bg-muted/50" : ""}>
                    <TableCell className="font-medium">{row.zone}</TableCell>
                    <TableCell className="text-center">{row.beforeHours}</TableCell>
                    <TableCell className="text-center">{row.beforeUnits}</TableCell>
                    <TableCell className="text-center text-sm">{row.beforeRebate}</TableCell>
                    <TableCell className="text-center">{row.beforeRebateAmount}</TableCell>
                    <TableCell className="text-center bg-orange-100">{row.afterHours}</TableCell>
                    <TableCell className="text-center bg-orange-100">{row.afterUnits}</TableCell>
                    <TableCell className="text-center text-sm max-w-xs bg-orange-100">{row.afterRebate}</TableCell>
                    <TableCell className="text-center bg-orange-100">{row.afterRebateAmount}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>

          {/* <div className="mt-4 p-4 bg-orange-50 border border-orange-200 rounded-lg">
                            <p className="text-sm text-orange-800 font-medium">
                                <strong>Overall bill impact:</strong> Total increase of approximately <>{BILL_COMPARIZON_DATA?.total?.percentageIncrease}</> in monthly HT bills due to MYT changes.
                            </p>
                        </div> */}
        </CardContent>
      </Card>
    </div>
  );
};

export default ImpactofChanges;
